import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationSidebarIcon: FC<PropsT> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M20 0C21.1046 0 22 0.895431 22 2V20C22 21.0357 21.2128 21.887 20.2041 21.9893L20 22H2L1.7959 21.9893C0.854346 21.8938 0.1062 21.1457 0.0107422 20.2041L0 20V2C0 0.895431 0.895431 3.22128e-08 2 0H20ZM2 1C1.44771 1 1 1.44772 1 2V20C1 20.5523 1.44772 21 2 21H20C20.5523 21 21 20.5523 21 20V2C21 1.44771 20.5523 1 20 1H2Z" fill="white"/>
    <path d="M7.5 21.3184H6.5V0.818359H7.5V21.3184Z" fill="white"/>
    <path d="M5 3C5.27614 3 5.5 3.22386 5.5 3.5C5.5 3.77614 5.27614 4 5 4H2.5C2.22386 4 2 3.77614 2 3.5C2 3.22386 2.22386 3 2.5 3H5Z" fill="white"/>
    <path d="M5 6C5.27614 6 5.5 6.22386 5.5 6.5C5.5 6.77614 5.27614 7 5 7H2.5C2.22386 7 2 6.77614 2 6.5C2 6.22386 2.22386 6 2.5 6H5Z" fill="white"/>
    <path d="M5 9C5.27614 9 5.5 9.22386 5.5 9.5C5.5 9.77614 5.27614 10 5 10H2.5C2.22386 10 2 9.77614 2 9.5C2 9.22386 2.22386 9 2.5 9H5Z" fill="white"/>
    <path d="M5 12C5.27614 12 5.5 12.2239 5.5 12.5C5.5 12.7761 5.27614 13 5 13H2.5C2.22386 13 2 12.7761 2 12.5C2 12.2239 2.22386 12 2.5 12H5Z" fill="white"/>
  </svg>
);

export default PresentationSidebarIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PresentationSidebarIcon: FC<PropsT> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path d="M20 0C21.1046 0 22 0.895431 22 2V20C22 21.0357 21.2128 21.887 20.2041 21.9893L20 22H2L1.7959 21.9893C0.854346 21.8938 0.1062 21.1457 0.0107422 20.2041L0 20V2C0 0.895431 0.895431 3.22128e-08 2 0H20ZM2 1C1.44771 1 1 1.44772 1 2V20C1 20.5523 1.44772 21 2 21H20C20.5523 21 21 20.5523 21 20V2C21 1.44771 20.5523 1 20 1H2Z" fill="white"/>
    <path d="M7.5 21.3184H6.5V0.818359H7.5V21.3184Z" fill="white"/>
    <path d="M5 3C5.27614 3 5.5 3.22386 5.5 3.5C5.5 3.77614 5.27614 4 5 4H2.5C2.22386 4 2 3.77614 2 3.5C2 3.22386 2.22386 3 2.5 3H5Z" fill="white"/>
    <path d="M5 6C5.27614 6 5.5 6.22386 5.5 6.5C5.5 6.77614 5.27614 7 5 7H2.5C2.22386 7 2 6.77614 2 6.5C2 6.22386 2.22386 6 2.5 6H5Z" fill="white"/>
    <path d="M5 9C5.27614 9 5.5 9.22386 5.5 9.5C5.5 9.77614 5.27614 10 5 10H2.5C2.22386 10 2 9.77614 2 9.5C2 9.22386 2.22386 9 2.5 9H5Z" fill="white"/>
    <path d="M5 12C5.27614 12 5.5 12.2239 5.5 12.5C5.5 12.7761 5.27614 13 5 13H2.5C2.22386 13 2 12.7761 2 12.5C2 12.2239 2.22386 12 2.5 12H5Z" fill="white"/>
  </svg>
);

export default PresentationSidebarIcon;
